module.exports = __webpack_public_path__ + "images/solent-d68c6bea866f05ce6c1a63c798d80156.jpg";